module.exports = __webpack_public_path__ + "static/img/重要通知300x300.d6b513cf.png";